//src/rtkQuery/config/notification.ts

export const NOTIFICATION_ENDPOINTS = {
  GET_ALL: '/notification/all',
  ACKNOWLEDGE: '/notification/acknowledge',
  VIEWED: '/notification/viewed',
};